import type { PersonalComposer } from "../../src/personal-composer-contract.ts";
import type { UnsentReply } from "./unsent-reply.ts";

/** The entire editor contents. A signature inside these words is never split or inferred. */
export type ComposerWords = {
  format: "text" | "html";
  plainText: string;
  html: string;
  fromDraft: number | null;
};

/** A modern local edit is marked even before its first server read supplies a known base. */
export type ComposerLocalBase = {
  composerManaged: true;
  composerRevision?: number;
  composerThreadVersion?: string;
};

export function composerWords(composer: PersonalComposer): ComposerWords | null {
  const content = composer.content;
  return content
    ? {
        format: content.format,
        plainText: content.plainText,
        html: content.format === "html" ? content.html : "",
        fromDraft: content.kind === "opaque" ? content.fromDraft : null,
      }
    : null;
}

export const unsentWords = (reply: UnsentReply): ComposerWords => ({
  format: reply.format,
  plainText: reply.text,
  html: reply.format === "html" ? reply.html : "",
  fromDraft: reply.fromDraft ?? null,
});

export function sameComposerWords(a: ComposerWords | null, b: ComposerWords | null): boolean {
  if (a === null || b === null) return a === b;
  return (
    a.format === b.format &&
    a.plainText === b.plainText &&
    (a.format === "text" || a.html === b.html) &&
    a.fromDraft === b.fromDraft
  );
}

export const nonemptyComposerWords = (words: ComposerWords): ComposerWords | null =>
  words.plainText.trim() ? words : null;
